import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
export default {
  name: "EditFeature",
  props: ["editedFeature", "global"],
  components: { InfoDialog },
  data: () => ({
    valueTypes: [
      { id: "", title: "Kein Wert" },
      { id: "string", title: "String" },
      { id: "integer", title: "Ganzzahl" },
      { id: "float", title: "Gleitkommazahl" }
    ],
    permissions: [
      { id: "all", title: "Alle" },
      { id: "events_admin", title: "Events Administrator" },
      { id: "admin", title: "OYA Admin" }
    ]
  })
};
